(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-engraving"] && !Shopify.designMode) return;
  try {
    
(function () {
  const wrap = document.getElementById('gp-engraving-{{ section.id }}');
  if (!wrap) return;

  const toggle = wrap.querySelector('.gp-engraving__toggle');
  const body = document.getElementById('gp-engraving-body-{{ section.id }}');
  const radio = wrap.querySelector('.gp-engraving__radio');
  const tabs = wrap.querySelectorAll('.gp-engraving__tab');
  const panels = wrap.querySelectorAll('.gp-engraving__panel');
  const textarea = document.getElementById('gp-engraving-text-{{ section.id }}');
  const charCurrent = wrap.querySelector('.gp-engraving__charcount-current');
  const saveBtn = document.getElementById('gp-engraving-save-{{ section.id }}');
  const savedBadge = document.getElementById('gp-engraving-saved-{{ section.id }}');
  const uploadBtn = document.getElementById('gp-engraving-upload-btn-{{ section.id }}');
  const fileInput = document.getElementById('gp-engraving-file-{{ section.id }}');
  const fileStatus = document.getElementById('gp-engraving-file-status-{{ section.id }}');
  const fileName = document.getElementById('gp-engraving-filename-{{ section.id }}');
  const typeInput = document.getElementById('gp-engraving-type-{{ section.id }}');
  const dropzone = document.getElementById('gp-engraving-dropzone-{{ section.id }}');
  const addonPrice = parseInt(wrap.dataset.addonPrice, 10); // in cents

  let isOpen = false;
  let activeTab = 'text';

  // ── Toggle open/close ──────────────────────────────────────────
  function openEngraving() {
    isOpen = true;
    body.hidden = false;
    wrap.classList.add('gp-engraving--active');
    toggle.setAttribute('aria-expanded', 'true');
    typeInput.value = activeTab;
    adjustCartPrice(true);
  }

  function closeEngraving() {
    isOpen = false;
    body.hidden = true;
    wrap.classList.remove('gp-engraving--active');
    toggle.setAttribute('aria-expanded', 'false');
    typeInput.value = '';
    textarea.value = '';
    charCurrent.textContent = '0';
    savedBadge.hidden = true;
    fileStatus.hidden = true;
    adjustCartPrice(false);
  }

  toggle.addEventListener('click', function () {
    isOpen ? closeEngraving() : openEngraving();
  });

  toggle.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      isOpen ? closeEngraving() : openEngraving();
    }
  });

  // ── Tab switching ───────────────────────────────────────────────
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activeTab = tab.dataset.tab;
      typeInput.value = activeTab;

      tabs.forEach(function (t) {
        const isActive = t === tab;
        t.classList.toggle('gp-engraving__tab--active', isActive);
        t.setAttribute('aria-selected', isActive);
      });

      panels.forEach(function (panel) {
        const match = panel.id.includes('gp-tab-' + activeTab);
        panel.hidden = !match;
        if (match) panel.classList.add('gp-engraving__panel--active');
        else panel.classList.remove('gp-engraving__panel--active');
      });
    });
  });

  // ── Character count ─────────────────────────────────────────────
 textarea.addEventListener('input', function () {
    if (textarea.value.length > 30) {
        textarea.value = textarea.value.slice(0, 30);
    }
    charCurrent.textContent = textarea.value.length;
    savedBadge.hidden = true;
});

  // ── Save text ───────────────────────────────────────────────────
  saveBtn.addEventListener('click', function () {
    if (!textarea.value.trim()) return;
    savedBadge.hidden = false;
  });

  // ── File upload ─────────────────────────────────────────────────
  uploadBtn.addEventListener('click', function () {
    fileInput.click();
  });

  fileInput.addEventListener('change', function () {
    if (fileInput.files && fileInput.files[0]) {
      fileName.textContent = fileInput.files[0].name;
      fileStatus.hidden = false;
    }
  });

  // Drag-and-drop support
  dropzone.addEventListener('dragover', function (e) {
    e.preventDefault();
    dropzone.classList.add('gp-drag-over');
  });

  dropzone.addEventListener('dragleave', function () {
    dropzone.classList.remove('gp-drag-over');
  });

  dropzone.addEventListener('drop', function (e) {
    e.preventDefault();
    dropzone.classList.remove('gp-drag-over');
    const files = e.dataTransfer.files;
    if (files && files[0]) {
      fileInput.files = files; // assign dropped file
      fileName.textContent = files[0].name;
      fileStatus.hidden = false;
    }
  });

  // ── Price adjustment ────────────────────────────────────────────
  // This fires a custom event so your theme's cart / product JS can
  // intercept it and add/remove the engraving price accordingly.
  // One simple approach: store the state in a data attribute and read
  // it in your product form's submit handler to inject a hidden variant.
  function adjustCartPrice(adding) {
    const event = new CustomEvent('gp:engraving:toggle', {
      bubbles: true,
      detail: { active: adding, price: addonPrice }
    });
    wrap.dispatchEvent(event);

    // Optionally update a visible subtotal badge on your product page
    const badge = document.querySelector('[data-engraving-price-badge]');
    if (badge) {
      badge.style.display = adding ? '' : 'none';
    }
  }

  // ── Cart form injection ─────────────────────────────────────────
  // Intercept the product form submit to inject the engraving line item
  // property into the form data before it hits Shopify.
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      if (!isOpen) return; // no engraving, proceed normally

      // Remove any previously injected hidden inputs
      productForm.querySelectorAll('[data-gp-engraving-prop]').forEach(function (el) {
        el.remove();
      });

      if (activeTab === 'text') {
        const val = textarea.value.trim();
        if (val) {
          injectHidden('properties[Engraving Text]', val);
        }
      }

      injectHidden('properties[_engraving_type]', activeTab);

      function injectHidden(name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.setAttribute('data-gp-engraving-prop', '');
        productForm.appendChild(input);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
